import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface SmallProps extends HTMLAttributes<HTMLElement> {}

const Small = forwardRef<HTMLElement, SmallProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <small
        ref={ref}
        className={cn('text-sm font-medium leading-none', className)}
        {...props}
      >
        {children}
      </small>
    );
  }
);

Small.displayName = 'Small';

export { Small };
